import { firestoreAction } from 'vuexfire'
import { Module, VuexModule, Action, getModule } from 'vuex-module-decorators'
import { firestore, Timestamp } from '../firebase'
import { UserStoreMod } from './user-store'
import store from './'
import { VendorFood } from 'foodme-firestore-db'

export interface VendorFoodCreate {
  title: string;
  description: string;
  price: string;
}

export interface VendorFoodUpdate {
  id: string;
  title: string;
  description: string;
  price: string;
}

@Module({ dynamic: true, store, name: 'food' })
class FoodStore extends VuexModule {
  foodList: Array<VendorFood> = []

  @Action
  async addFood (newFood: VendorFoodCreate) {
    const food: VendorFood = {
      ...newFood,
      vendorId: UserStoreMod.vendorId,
      createdDate: Timestamp.now(),
      createdBy: UserStoreMod.user.id
    }
    await firestore.collection('food').add(food)
  }

  @Action
  bindFoodList () {
    return (firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef('foodList', firestore.collection('food').where('vendorId', '==', UserStoreMod.vendorId))
    }) as Function)(this.context)
  }

  @Action
  async saveFood (updatedFood: VendorFoodUpdate) {
    // console.log('food-store saveFood')
    const food: VendorFood = {
      ...updatedFood,
      modifiedDate: Timestamp.now(),
      modifiedBy: UserStoreMod.user.id
    }
    await firestore.collection('food').doc(food.id).update(food)
  }
}

export const foodStore = getModule(FoodStore)
